import moment from 'moment'
// export const getCurrentTime = () => {
//   const myDate = moment.utc().utcOffset('+03:00').format('DD-MM-YYYY HH:mm:ss')

//   return myDate
// }

export const getCurrentTime = () => {
  const myDate = moment.utc().utcOffset('+03:00').toDate() // returns JS Date object
  return myDate
}
